export default __webpack_public_path__ + "static/media/values.e6f28b00.png";